
import { defineComponent, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { formatContractBusinessType } from '@/helpers/formatContractBusinessType';
import { formatContractType } from '@/helpers/formatContractType';
import { Company } from '@/gql/graphql';

const contractTypeNames = {
  online: 'Онлайн договор',
  custom: 'Онлайн договор',
  offline: 'Оффлайн договор',
};

export default defineComponent({
  props: {
    selectedItemId: {
      type: String,
      default: '',
    },
    isSelectedCompanyNumberVisible: {
      type: Boolean,
      default: true,
    },
    expandToTop: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['select'],

  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const company = computed<Company>(() => store.getters['cabinet/company']);
    const companies = computed<Company[]>(() => store.getters['cabinet/companies']);
    const getCompanyRouteTypeById = computed(() => store.getters['cabinet/getCompanyRouteTypeById']);

    const companySelectOptions = computed(() => {
      if (!companies.value) {
        return [];
      }

      return companies.value.map((company) => {
        const contracts = company.contracts;

        if (company.type !== 'internal' && contracts.length > 1) {
          return {
            label: company.name,
            value: company.id,
            children: contracts.map((contract) => {
              const contractTypeTitle = formatContractType(contract.type);
              const contractNumber = contract.number || 'Номер отсутствует';
              const contractBusinessType = formatContractBusinessType(contract.businessType);
              const contractNumberTitle = [contractBusinessType, contractNumber].join(' | ');

              return {
                label: [contractTypeTitle, contractNumberTitle],
                value: contract.id,
              };
            }),
          };
        }

        return {
          label: company.name,
          value: company.id,
        };
      });
    });

    return {
      companySelectOptions,

      selectedCompanyName: computed(() => company.value?.name),
      selectedCompanyNumber: computed(() => {
        const number = company.value?.contract?.number;
        if (!number) {
          return '';
        }

        const contractTypeCode = company.value?.contract?.type;
        const type = (contractTypeCode && contractTypeNames[contractTypeCode]) ?? 'Договор';
        return number ? `${type}: №${number}` : '';
      }),

      selectedCompany: computed(() => [props.selectedItemId]),

      selectCompany(selectedMenuItem: { key: string }) {
        const companyId = selectedMenuItem.key || '';

        emit('select', companyId);

        router.push({
          ...route,
          params: {
            ...route.params,
            id: companyId,
            type: getCompanyRouteTypeById.value(companyId),
          },
          query: undefined,
        });
      },
    };
  },
});
